export default __webpack_public_path__ + "static/media/file-regular.ff82704d.svg";